import { QRCodeCanvas } from "qrcode.react";
import "../css/dash.css";

export default function Qrcode({ menu }) {
  const downloadQR = () => {
    const canvas = document.getElementById(`qr-code-canvas-${menu.id}`);
    const pngUrl = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");

    const downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = `${menu.name}-QR.png`;
    downloadLink.click();
  };

  return (
    <div className="qrCard">
      <h2 className="qr-title">{menu.name}</h2>

      <div className="qr-wrapper">
        <QRCodeCanvas
          id={`qr-code-canvas-${menu.id}`}
          value={`https:/menulinker.com/${menu.id}`}
          className="qr-image"
        />
      </div>

      <button className="qr-btn" onClick={downloadQR}>
        Download QR
      </button>
    </div>
  );
}
